import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  OnDestroy,
  ViewChild,
  Output,
  EventEmitter,
  Input
} from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  Validators
} from '@angular/forms';
import {
  CheckItem,
  Pais,
  TipoRol,
  TiposDocumento,
  createEmptyCheckListFormInput
} from '@rpe/registro-personas-empresas-lib';
import { BehaviorSubject, Observable, Subscription, combineLatest } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { State } from '../../../../vista-usuario/vista-usuario.state';
import { selectCurrentEmpresa } from '../../../entity-mis-empresas/entity-current-empresa.selectors';
import { MatSelectChange } from '@angular/material/select';
import { selectAllTiposRol } from '../../../../roles/entity-tipos-rol/entity-tipos-rol.selectors';
import { selectAllTiposDocumento } from '../../../../persona/entity-tipos-documento/entity-tipos-documento.selectors';
import { selectAllPaises } from '../../../../ubicaciones/entity-paises/entity-paises.selectors';
import { entityIntegranteAddRequest } from '../../../../roles/entity-integrante/entity-integrante.actions';
import {
  DocumentoPersona,
  DocumentoPersonaSet
} from '../../../../persona/documentos-persona/documentos-persona.model';
import { selectDocumentoPersonaInitialData } from '../../../../persona/documentos-persona/documentos-persona.selectors';
import { Laboratorio } from '../../../../actividades/entity-laboratorios/laboratorios.model';
import {
  FileService,
  NotificationService
} from 'projects/registro-personas-empresas/src/app/core/core.module';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { NaturalezaJuridica } from '../../../entity-naturalezas-juridica/naturalezas-juridica.model';
import { selectEntidadesProductivaFromCurrentEmpresa } from '../../../entity-entidad-productiva/entity-entidades-productiva.selectors';
import { EntidadesProductiva } from '../../../entity-entidad-productiva/entity-entidades-productiva.model';
import { PersonasJuridica } from '../../../entity-personas-juridica/entity-personas-juridica.model';
import { Persona } from '../../../../persona/entity-personas/entity-personas.model';
import { certificado_notarial_tooltip } from 'projects/registro-personas-empresas/src/app/shared/util/util';
import {
  selectIntegranteAddedSuccess,
  selectIntegrantesCurrentEmpresa
} from '../../../../roles/entity-integrante/entity-integrante.selectors';
import { selectAllLaboratoriosFromCurrentEmpresa } from '../../../../actividades/entity-laboratorios/laboratorios.selectors';
import { tap } from 'rxjs/operators';
import { Integrante } from '../../../../roles/integrante/integrante.model';
import CIValidator from '../../../../persona/documentos-persona/documentos-persona.validators';
import { emailValidator } from 'projects/registro-personas-empresas/src/app/shared/validators/email-validators';

@Component({
  selector: 'rpe-registro-integrante-form',
  templateUrl: './registro-integrante-form.component.html',
  styleUrls: ['./registro-integrante-form.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class RegistroIntegranteFormComponent implements OnInit, OnDestroy {
  @Input() laboratorios: Laboratorio[] = [];
  @Input() personaJuridica: PersonasJuridica = null;
  @Input() personaFisica: Persona = null;
  @Input() naturalezasJuridicas: NaturalezaJuridica[] = [];

  @Output() onCancel: EventEmitter<void> = new EventEmitter<void>();

  _documentoInput = new BehaviorSubject<DocumentoPersona>(null);

  subscription: Subscription[] = [];

  nombreCompleto: FormControl = new FormControl(null, [Validators.required]);
  idDocumento: FormControl = new FormControl(null);
  pais_codigo: FormControl = new FormControl('uy', [Validators.required]);
  tipo_documento_codigo: FormControl = new FormControl(68909, [
    Validators.required
  ]);
  correo_electronico: FormControl = new FormControl(null, [emailValidator]);
  numero: FormControl = new FormControl(null, [Validators.required]);
  certificado_notarial: FormControl = new FormControl(null, []);
  acreditacion_representacion: FormControl = new FormControl(null, []);
  idRol: FormControl = new FormControl(null, []);
  persona_id: FormControl = new FormControl(null, []);
  entidad_productiva_id: FormControl = new FormControl(null);
  es_creador: FormControl = new FormControl(true, []);
  fecha_alta: FormControl = new FormControl(
    new Date().toISOString().split('T')[0],
    []
  );
  fecha_baja: FormControl = new FormControl(null, []);
  vinculo_aprobado_rol: FormControl = new FormControl(false, []);
  vinculo_aprobado_entidad_productiva: FormControl = new FormControl(true, []);
  eliminado: FormControl = new FormControl(false, []);
  tipo_rol_id: FormControl = new FormControl([null, [Validators.required]]);
  integranteFormGroup: FormGroup = new FormGroup({});
  documentoPersonaFormGroup: FormGroup = new FormGroup({
    id: this.idDocumento,
    pais_codigo: this.pais_codigo,
    tipo_documento_codigo: this.tipo_documento_codigo,
    numero: this.numero
  });

  rolFormGroup: FormGroup = new FormGroup({
    persona_id: this.persona_id,
    entidad_productiva_id: this.entidad_productiva_id,
    acreditacion_representacion: this.acreditacion_representacion,
    es_creador: this.es_creador,
    fecha_alta: this.fecha_alta,
    fecha_baja: this.fecha_baja,
    vinculo_aprobado_rol: this.vinculo_aprobado_rol,
    vinculo_aprobado_entidad_productiva:
      this.vinculo_aprobado_entidad_productiva,
    eliminado: this.eliminado,
    tipo_rol_id: this.tipo_rol_id
  });

  ocultoActividades: boolean = true;
  allComplete: boolean = false;
  isAnalista: boolean = false;
  tituloIntegrante: string;

  documentoPersonaSet$: Observable<DocumentoPersonaSet>;
  documentoPersonaSet: DocumentoPersonaSet;

  entidadProductiva: EntidadesProductiva;

  roles: TipoRol[] = [];
  allRoles: TipoRol[] = [];
  tiposDocumentosFiltrado: TiposDocumento[];
  paises: Pais[] = [];
  checkItem: CheckItem[] = [];
  integrantes: Integrante[] = [];
  selectedLabs: number[] = [];

  formCheckLab = createEmptyCheckListFormInput();
  firstTime = true;

  tecnicosResposables: Integrante[] = [];
  //Validators CI
  typeDoc = 'text';
  numberDoc = 'Número:';

  get isTecnicoResponsable(): boolean {
    return String(this.idRol.value) === '6';
  }

  get needAcreditacionRepresentacion(): boolean {
    return (
      String(this.idRol.value) === '2' ||
      String(this.idRol.value) === '3' ||
      String(this.idRol.value) === '5'
    );
  }

  get certificadoNotarialTooltip(): string {
    return certificado_notarial_tooltip;
  }

  constructor(
    public store: Store<State>,
    private notificationService: NotificationService,
    private fileService: FileService
  ) {
    this.tituloIntegrante = 'Registrar integrante';
  }

  ngOnInit(): void {
    const currentEmpresa = this.store
      .select(selectCurrentEmpresa)
      .subscribe((currentEmpresa) => {
        currentEmpresa
          ? this.entidad_productiva_id.setValue(currentEmpresa.id)
          : '';
      });
    const allTiposRol = this.store
      .select(selectAllTiposRol)
      .subscribe((roles) => {
        return roles
          ? (this.roles = roles.filter((r) => {
              return this.personaJuridica ? r.pj : r.pf;
            }))
          : '';
      });
    const entidadProductiva = this.store
      .select(selectEntidadesProductivaFromCurrentEmpresa)
      .subscribe((entidadProductiva) => {
        entidadProductiva
          ? (this.entidadProductiva = entidadProductiva[0])
          : '';

        if (this.personaJuridica) {
          const naturalezaJuridica = this.naturalezasJuridicas.find(
            (nj) => nj.id === this.personaJuridica.naturaleza_juridica_id
          );

          if (naturalezaJuridica.id != 15) {
            this.roles = this.roles.filter((rol) => rol.id != 1);
          }
        }

        /*const rolesByOrder = [
          'Representante',
          'Apoderado',
          'Administrativo responsable',
          'Técnico responsable',
          'Analista de laboratorio',
          'Titular',
          'Representante legal'
        ];

        this.roles = this.roles.sort((a, b) => {
          return (
            rolesByOrder.indexOf(a.nombre) - rolesByOrder.indexOf(b.nombre)
          );
        });*/

        this.allRoles = this.roles;
      });

    const currentLaboratorio = this.store
      .pipe(select(selectAllLaboratoriosFromCurrentEmpresa))
      .pipe(
        tap((laboratorios) => {
          if (laboratorios.length <= 0 || !laboratorios.length) {
            this.roles = this.roles.filter((rol) => rol.id != 7);
          } else {
            this.roles = this.allRoles;
          }
        })
      )
      .subscribe();

    const tiposDocumento = this.store
      .select(selectAllTiposDocumento)
      .subscribe((tiposDocumento) => {
        tiposDocumento ? (this.tiposDocumentosFiltrado = tiposDocumento) : '';
      });
    const allPaises = this.store.select(selectAllPaises).subscribe((paises) => {
      paises ? (this.paises = paises) : '';
    });

    this.documentoPersonaSet$ = this.store.pipe(
      select(selectDocumentoPersonaInitialData)
    );

    const docPersona = combineLatest([
      this.documentoPersonaSet$,
      this._documentoInput
    ]).subscribe(([set, documento]) => {
      this.documentoPersonaSet = set;
      this.setValorDocumento(documento);
    });

    const addedIntegrante = this.store
      .select(selectIntegranteAddedSuccess)
      .subscribe((added) => {
        if (this.firstTime) {
          this.firstTime = false;
        } else {
          if (added) {
            this.onCancelClick();
          }
        }
      });

    const integrantesCurrentEmpresa = this.store
      .select(selectIntegrantesCurrentEmpresa)
      .subscribe((integrantes) => {
        this.integrantes = integrantes;

        const tecnicoResponsableRol = this.roles.find((rol) => rol.id === 6);

        this.tecnicosResposables = integrantes.filter(
          (integrante) =>
            integrante.rol.tipo_rol_id === tecnicoResponsableRol.id
        );
      });

    this.subscription.push(
      currentEmpresa,
      entidadProductiva,
      allTiposRol,
      tiposDocumento,
      allPaises,
      docPersona,
      addedIntegrante,
      currentLaboratorio,
      integrantesCurrentEmpresa
    );
  }

  ngOnDestroy(): void {
    this.subscription.forEach((sub) => sub.unsubscribe());
  }

  onRolSelect(event: MatSelectChange): void {
    this.isAnalista =
      this.roles.find((rol) => {
        return rol.id === event.value;
      }).nombre === 'Analista de laboratorio';

    this.tipo_rol_id.setValue(event.value);

    if (this.isTecnicoResponsable) {
      this.correo_electronico.setValidators([
        emailValidator,
        Validators.required
      ]);
    } else {
      this.correo_electronico.clearValidators();
    }
  }

  minLengthArray = (min: number) => {
    return (c: AbstractControl): { [key: string]: any } => {
      if (c.value.length >= min) return null;
      return { MinLengthArray: true };
    };
  };

  addPersona(): void {
    //Se saco porque se pueden registar mas de 1 tecnico responsable en la empresa
    // if (
    //   this.rolFormGroup.value.id === 6 &&
    //   this.tecnicosResposables.length > 0
    // ) {
    //   this.notificationService.info(
    //     'Ya existe un técnico responsable en la empresa'
    //   );
    //   return;
    // }

    let data: any = {
      nombre_completo: this.nombreCompleto.value,
      documento_persona: this.documentoPersonaFormGroup.value,
      rol: this.rolFormGroup.value,
      laboratorios_id: this.selectedLabs
    };

    if (this.isTecnicoResponsable && this.correo_electronico.invalid) {
      this.notificationService.info('Debe ingresar un correo electrónico');
      return;
    }

    if (this.isTecnicoResponsable) {
      data = {
        ...data,
        correo_electronico: this.correo_electronico.value
      };
    }

    if (
      this.nombreCompleto.invalid ||
      this.documentoPersonaFormGroup.invalid ||
      this.rolFormGroup.invalid ||
      this.idRol.invalid
    ) {
      this.notificationService.info('Debe completar todos los campos');
      return;
    }

    if (this.isAnalista && !this.selectedLabs.length) {
      this.notificationService.info('Debe seleccionar al menos un laboratorio');
      return;
    }

    if (this.needAcreditacionRepresentacion) {
      if (!this.acreditacion_representacion.value) {
        this.notificationService.info(
          'Debe cargar la acreditación de representación'
        );
        return;
      } else {
        this.fileService
          .uploadFile(data.rol.acreditacion_representacion)
          .subscribe((file) => {
            data = {
              ...data,
              rol: {
                ...data.rol,
                acreditacion_representacion: file
              }
            };
            this.store.dispatch(
              entityIntegranteAddRequest({
                item: data as any
              })
            );
          });
      }
    } else {
      this.store.dispatch(
        entityIntegranteAddRequest({
          item: data as any
        })
      );
    }
  }

  onCancelClick(): void {
    this.onCancel.emit();
  }

  onFileChange(texto: string) {}

  setValorDocumento(documento: DocumentoPersona): void {
    if (documento && this.documentoPersonaSet) {
      const paisesDocumentoSeleccionado =
        this.documentoPersonaSet.paisesDocumento.filter(
          (pd) => pd.pais_codigo === documento.pais_codigo
        );
      this.tiposDocumentosFiltrado =
        this.documentoPersonaSet.tiposDocumento.filter(
          (td) =>
            paisesDocumentoSeleccionado.findIndex(
              (pd) => pd.tipo_documento_codigo == td.codigo
            ) !== -1
        );
      this.documentoPersonaFormGroup.patchValue({
        pais_codigo: documento.pais_codigo,
        tipo_documento_codigo: documento.tipo_documento_codigo,
        numero: documento.numero
      });
    } else {
      if (this.documentoPersonaFormGroup.get('pais_codigo').value) {
        const pais_codigo: MatSelectChange = {
          value: this.documentoPersonaFormGroup.get('pais_codigo').value,
          source: null
        };
        this.onChangePais(pais_codigo);
      }
    }
  }

  onChangePais(evt: MatSelectChange) {
    const paisSeleccionado = evt.value;
    const paisesDocumentoSeleccionado =
      this.documentoPersonaSet.paisesDocumento.filter(
        (pd) => pd.pais_codigo === paisSeleccionado
      );

    this.tiposDocumentosFiltrado =
      this.documentoPersonaSet.tiposDocumento.filter(
        (td) =>
          paisesDocumentoSeleccionado.findIndex(
            (pd) => pd.tipo_documento_codigo == td.codigo
          ) !== -1
      );

    // Si el pais es uruguay dejo como number el ci
    if (paisSeleccionado == 'uy') {
      this.typeDoc = 'number';
      this.numberDoc = 'Número (sin puntos ni guiones):';
      this.numero.setValidators([Validators.required, CIValidator]);
    } else {
      this.typeDoc = 'text';
      this.numberDoc = 'Número:';
      this.numero.setValue(null);
      this.numero.setValidators([Validators.required]);
    }
    this.numero.updateValueAndValidity();
  }

  onLabChange($event: MatCheckboxChange, laboratorio: Laboratorio) {
    if ($event.checked) {
      this.selectedLabs.push(laboratorio.id);
    } else {
      this.selectedLabs = this.selectedLabs.filter(
        (lab) => lab !== laboratorio.id
      );
    }
  }
}
